import { useEffect, useState } from "react";
import api from "@/lib/api";
import { gbp } from "./constants";

export default function AdminOrders() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/orders").then(({ data }) => setItems(data.items)); }, []);
    return (
        <div data-testid="admin-orders">
            <div style={{ marginBottom: 16, fontFamily: "var(--font-serif)" }}>{items.length} orders</div>
            <table className="admin-table">
                <thead><tr><th>Date</th><th>Order</th><th>Buyer</th><th>Items</th><th>Total</th><th>Status</th></tr></thead>
                <tbody>
                    {items.map((o) => (
                        <tr key={o.id}>
                            <td style={{ fontFamily: "var(--font-sans)", fontSize: 11 }}>{new Date(o.created_at).toLocaleDateString("en-GB")}</td>
                            <td style={{ fontFamily: "monospace", fontSize: 11 }}>{o.id.slice(-8)}</td>
                            <td>{o.email}</td>
                            <td>{o.line_items?.length}</td>
                            <td>{gbp(o.total)}</td>
                            <td><span className={`status-pill ${o.status}`}>{o.status}</span></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
